// Capitolato Form Data and Templates
// This file contains all dropdown options, descriptions, and text templates for PDF generation

// Ninfa Model Options
export const NINFA_MODELS = [
    { value: 'NINFA 106', label: 'NINFA 106', code: 'N106' },
    { value: 'NINFA 116', label: 'NINFA 116', code: 'N116' },
    { value: 'NINFA 56', label: 'NINFA 56', code: 'N56' },
    { value: 'NINFA 50N', label: 'NINFA 50N', code: 'N50N' },
    { value: 'NINFA 176', label: 'NINFA 176', code: 'N176' },
    { value: 'NINFA 186', label: 'NINFA 186', code: 'N186' },
    { value: 'NINFA 6', label: 'NINFA 6', code: 'N6' },
    { value: 'NINFA 6 STADIO', label: 'NINFA 6 STADIO', code: 'NSTADIO2' }
];

// Category Options
export const CATEGORY_OPTIONS = [
    { value: 'C2-T', label: 'Classe C2 – TEST DI LABORATORIO' },
    { value: 'C3-T', label: 'Classe C3 – TEST DI LABORATORIO' },
    { value: 'UNI132003-T', label: 'UNI 132003 - Crush Barrier – TEST DI LABORATORIO' },
    { value: 'C2-C', label: 'Classe C2 – CALCOLO DI ELEMENTI FINITI' },
    { value: 'C3-C', label: 'Classe C3 – CALCOLO DI ELEMENTI FINITI' },
    { value: 'UNI132003-C', label: 'UNI 132003 - Crush Barrier - CALCOLO DI ELEMENTI FINITI' },
];

// Aluminum Finish Options
export const FINISH_OPTIONS = [
    {
        value: 'ANODIZZATA_ARGENTO',
        label: 'ANODIZZATA ARGENTO',
        description: 'I profili in alluminio posizionati a "vista" saranno anodizzati al colore argento. Lo spessore anodico dovrà essere della classe 20 micron, il tutto nel rispetto delle indicazioni del marchio Qualanod'
    },
    {
        value: 'VERNICIATO_9010',
        label: 'VERNICIATO RAL 9010 OPACO',
        description: 'I profili in alluminio posizionati a "vista" saranno verniciati con polvere poliestere nel rispetto delle indicazioni del marchio Qualicoat, nel colore RAL 9010 opaco.'
    },
    {
        value: 'VERNICIATO_9005',
        label: 'VERNICIATO RAL 9005 OPACO',
        description: 'I profili in alluminio posizionati a "vista" saranno verniciati con polvere poliestere nel rispetto delle indicazioni del marchio Qualicoat, nel colore RAL 9005 opaco.'
    },
    {
        value: 'VERNICIATO_CUSTOM',
        label: 'VERNICIATO RAL (immettere codice)',
        description: 'I profili in alluminio posizionati a "vista" saranno verniciati con polvere poliestere nel rispetto delle indicazioni del marchio Qualicoat, nel colore RAL {CODE}.',
        requiresCode: true
    }
];

// Glass Thickness Options
export const GLASS_OPTIONS = [
    {
        value: '6+6_SG',
        label: '6+6 TEMP.+SG+TEMP',
        description: 'VETRO, due lastre temperate-stratificate con intercalare rigido, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 6+6 stratificate con interlayer tipo SG di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '8+8_EVA',
        label: '8+8 TEMP.+EVA+IND.',
        description: 'VETRO, una lastra temperata ed una lastra temperata/indurita, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 8+8 stratificate con interlayer tipo PVB o Eva di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '8+8_SG',
        label: '8+8 TEMP.+SG+TEMP.',
        description: 'VETRO, due lastre temperate-stratificate con intercalare rigido, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 8+8 stratificate con interlayer tipo SG di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '10+10_EVA',
        label: '10+10 TEMP.+EVA+IND.',
        description: 'VETRO, una lastra temperata ed una lastra temperata/indurita, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 10+10 stratificate con interlayer tipo PVB o Eva di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '10+10_SG',
        label: '10+10 TEMP.+SG+TEMP.',
        description: 'VETRO, due lastre temperate-stratificate con intercalare rigido, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 10+10 stratificate con interlayer tipo SG di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '12+12_EVA',
        label: '12+12 TEMP.+EVA+IND.',
        description: 'VETRO, una lastra temperata ed una lastra temperata/indurita, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 12+12 stratificate con interlayer tipo PVB o Eva di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    },
    {
        value: '12+12_SG',
        label: '12+12 TEMP.+SG+TEMP.',
        description: 'VETRO, due lastre temperate-stratificate con intercalare rigido, per poter garantire il requisito PR - post rottura - in accordo alla nota 3 della UNI 7697:2021. Le due lastre di vetro possono avere uno spessore minimo di mm 12+12 stratificate con interlayer tipo SG di spessore minimo 0,76 mm, con altezza minima da pavimento pari a 1100 mm.'
    }
];

// Fixing Type Options
export const FIXING_OPTIONS = [
    {
        value: 'INOX_A4_200',
        label: 'ACCIAIO INOX A4 - Hilti HIT-Re 500 V4 o Hilti HY-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio inox A4, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Si raccomanda di fare attenzione al fissaggio con eventuale foratura di guaina sottostante, in tal caso, per evitare infiltrazioni di acqua nel solaio, usare resina speciale che possa consentire la chiusura del foro tra resina e guaina (tipo Hilti HIT-Re 500 V4). Il passo di fissaggio è previsto ogni 20 cm.'
    },
    {
        value: 'ZINCATO_A4_200',
        label: 'ACCIAIO ZINCATO - Hilti HIT-Re 500 V4 o Hilti HY-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio zincato, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Si raccomanda di fare attenzione al fissaggio con eventuale foratura di guaina sottostante, in tal caso, per evitare infiltrazioni di acqua nel solaio, usare resina speciale che possa consentire la chiusura del foro tra resina e guaina (tipo Hilti HIT-Re 500 V4). Il passo di fissaggio è previsto ogni 20 cm.'
    },
    {
        value: 'INOX_A4_300',
        label: 'ACCIAIO INOX A4 - 116 - Hilti HIT-Re 500 V4 o Hilti HY-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio inox A4, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Si raccomanda di fare attenzione al fissaggio con eventuale foratura di guaina sottostante, in tal caso, per evitare infiltrazioni di acqua nel solaio, usare resina speciale che possa consentire la chiusura del foro tra resina e guaina (tipo Hilti HIT-Re 500 V4). Il passo di fissaggio è previsto ogni 30 cm.'
    },
    {
        value: 'ZINCATO_A4_300',
        label: 'ACCIAIO ZINCATO - 116 - Hilti HIT-Re 500 V4 o Hilti HY-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio zincato, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Si raccomanda di fare attenzione al fissaggio con eventuale foratura di guaina sottostante, in tal caso, per evitare infiltrazioni di acqua nel solaio, usare resina speciale che possa consentire la chiusura del foro tra resina e guaina (tipo Hilti HIT-Re 500 V4). Il passo di fissaggio è previsto ogni 30 cm.'
    },
    {
        value: 'INOX_A4_SF',
        label: 'ACCIAIO INOX A4 - Hilti HI-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio inox A4, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Il passo di fissaggio è previsto ogni 20 cm.'
    },
    {
        value: 'ZINCATO_A4_FS',
        label: 'ACCIAIO ZINCATO - Hilti HI-170',
        description: 'Per il fissaggio del profilo verranno usate astine filettate in acciaio zincato, affogate con resina chimica. Il fissaggio deve avvenire su trave o soletta in cemento armato ed assicurarsi che il calcestruzzo sia di classe minima C25/30. Il passo di fissaggio è previsto ogni 20 cm.'
    },
];

// Drainage Holes Options
export const DRAINAGE_HOLES_OPTIONS = [
    {
        value: 'SI',
        label: 'SI',
        description: 'Il profilo è previsto di fori di scarico acqua. L\'eventuale acqua che entra nel profilo in alluminio potrà uscire dai fori di scarico presenti sul lato esterno del profilo stesso.'
    },
    {
        value: 'NO',
        label: 'NO',
        description: ''
    }
];

// Milling Options
export const MILLING_OPTIONS = [
    {
        value: 'SI',
        label: 'SI',
        description: 'Il profilo è previsto di fresature di scarico acqua. L\'eventuale acqua che defluisce dalle aree antistanti potrà uscire dalle fresature passanti presenti sul profilo stesso.'
    },
    {
        value: 'NO',
        label: 'NO',
        description: ''
    }
];

// Plates Options
export const PLATES_OPTIONS = [
    {
        value: 'SI',
        label: 'SI',
        description: 'Il profilo viene montato su specifici spessori di scarico acqua. L\'eventuale acqua che defluisce dalle aree antistanti potrà uscire dagli spazi che si vengono a creare tra uno spessore e l\'altro.'
    },
    {
        value: 'NO',
        label: 'NO',
        description: ''
    }
];

// Model to renders folder mapping
export const MODEL_RENDER_FOLDER = {
    'NINFA 106': '106',
    'NINFA 116': '116',
    'NINFA 56': '56',
    'NINFA 50N': '50-N',
    'NINFA 176': '176',
    'NINFA 186': '186',
    'NINFA 6': '6',
    'NINFA 6 STADIO': '6 STADIO'
};

// Model to declaration files mapping (dichiarazioni di conformità)
// Category suffix -T = test, -C = calcoli
export const MODEL_DECLARATION_FILES = {
    'NINFA 106': { test: 'NINFA 106 - test.jpg', calcoli: 'NINFA 106 - calcoli.jpg' },
    'NINFA 116': { test: 'NINFA 116 - test.jpg', calcoli: 'NINFA 116 - calcoli.jpg' },
    'NINFA 56': { test: 'NINFA 56 - test.jpg', calcoli: 'NINFA 56 - calcoli.jpg' },
    'NINFA 50N': { test: 'NINFA 50-N - test.jpg' },
    'NINFA 176': { test: 'NINFA 176 - test.jpg', calcoli: 'NINFA 176 - calcoli.jpg' },
    'NINFA 186': { test: 'NINFA 186 - test.jpg', calcoli: 'NINFA 186 - calcoli.jpg' },
    'NINFA 6': { test: 'NINFA 6 - test.jpg', calcoli: 'NINFA 6 - calcoli.jpg' },
    'NINFA 6 STADIO': { test: 'NINFA 6 STADIO - test.jpg', calcoli: 'NINFA 6 STADIO - calcoli.jpg' }
};

// Render Image Mapping (using existing images in public/images/profiles/)
export const RENDER_IMAGES = {
    'NINFA 106': '/images/profiles/N106.png',
    'NINFA 116': '/images/profiles/N116.png',
    'NINFA 56': '/images/profiles/N56.png',
    'NINFA 50N': '/images/profiles/N50N.png',
    'NINFA 176': '/images/profiles/N176.png',
    'NINFA 186': '/images/profiles/N186.png',
    'NINFA 6': '/images/profiles/N6.png',
    'NINFA 6 STADIO': '/images/profiles/NSTADIO2.png'
};

// PDF Template Texts

export const INTRO_TEXT = `A seguito della richiesta ricevuta, ringraziamo per l'opportunità e siamo lieti risponderVi.

E' utile premettere che la nostra azienda produce e commercializza sistemi di fissaggio per realizzare interventi in vetro, mettendo a disposizione dei progettisti un ufficio in grado di soddisfare esigenze di natura tecnica. In questa fase preliminare, in mancanza di un progetto esecutivo da esaminare, la presente offerta ha l'obiettivo di determinare un prezzo indicativo per orientarsi sul budget di spesa. L'eventuale fornitura e messa in opera delle opera sarà realizzata da un ns partner di fiducia. (Faraone Club Expert)

Le voci incluse nella presente quotazione sono:
• Sistema di fissaggio in alluminio, per realizzare la balaustra in vetro Ninfa
• Vetri;
• Installazione;
• La fornitura dei profili, dei vetri e la posa

Restano escluse dalla presente offerta e dalla nostra fornitura le seguenti voci:
• Quanto non espressamente citato.`;

export const NORMATIVE_SECTIONS = {
    title: 'Normative contemplate',
    norms: [
        {
            number: '1',
            title: 'DM 17/01/2018 - Norme tecniche per le costruzioni',
            content: `E' la legge che definisce i carichi e le verifiche sulle strutture in Italia. E' la normativa cogente che va necessariamente applicata sulle strutture e, quindi, anche sui parapetti.

Secondo il DM17/01/2018 i carichi nominali da applicare sulle balaustre sono, a seconda della destinazione d'uso:

2 kN/m per le categorie A, B, C1, C2;
3 kN/m per le categorie C3, C4, C5.`
        },
        {
            number: '2',
            title: 'UNI 7697:2021 - Criteri di sicurezza nelle applicazioni vetrarie',
            content: `Definisce principalmente la scelta della tipologia di vetro da impiegare a seconda della prestazione minima richiesta.

Questa normativa è importante poiché pone l'attenzione sul criterio PR: La sigla "PR" (post-rottura) implica che i vetri impiegati per realizzare i parapetti non devono collassare immediatamente nel caso in cui tutte le lastre risultino rotte.

Utilizzando un intercalare rigido o una delle due lastre indurite, il Criterio PR è garantito.`
        },
        {
            number: '3',
            title: 'UNI 11678:2017 - Vetro per edilizia - Elementi di tamponamento in vetro aventi funzione anticaduta - Resistenza al carico statico lineare ed al carico dinamico - Metodi di prova',
            content: `Definisce i metodi di prova per determinare il comportamento ai carichi statici linearmente distribuiti e ai carichi dinamici di elementi di tamponamento in vetro avente funzione di anti-caduta. La norma è entrata ufficialmente in vigore in data 11/05/2017 ed è caratterizzata dalle seguenti fasi:

• Controllo della resistenza allo Stato limite Ultimo Esercizio e la relativa flessione massima del vetro in esercizio pari a 100 mm e flessione residua dopo 15 min dalla rimozione del carico pari a 10 mm;

• Controllo della resistenza allo Stato limite Ultimo con amplificazione del carico di esercizio mediante fattore di sicurezza pari a 1,5. Pertanto il carico di 200 kg/m della viene portato a 300 kg/m e il carico di 300 kg/m viene portato a 450 kg/m;

• Controllo della resistenza allo Stato limite di Collasso mediante rottura indotta di una lastra;

• Prova di impatto da corpo duro per la verifica di resistenza del vetro agli urti accidentali di elementi metallici;

• Prova di impatto da corpo semirigido, con determinazione esatta delle altezze di caduta (a seconda della destinazione d'uso) e dei punti di impatto del pendolo.`
        },
        {
            number: '4',
            title: 'UNI 10809:1999 - Ringhiere, balaustre o parapetti prefabbricati',
            content: `Definisce i requisiti geometrico-prestazionali delle balaustre (altezza minima, scalabilità, inattraversabilità, impugnabilità del passamano).`
        }
    ]
};

export const MATERIALS_TEXT = `Parapetto - balaustra o ringhiera, adatto per la posa in opera sopra al pavimento, realizzata con profili estrusi in lega di alluminio posizionati alla base del parapetto. La lega di alluminio è la 6063 T66; il profilo avrà le dimensioni e la geometria interna appositamente ingegnerizzata per poter garantire sia la rigidezza in caso di spinta statica e sia la flessibilità necessaria per assorbire gli urti accidentali in accordo alla UNI 11678:2017.`;

export const ACCESSORIES_TEXT = `il fissaggio del vetro sul profilo di alluminio avviene tramite speciali accessori realizzati in PA66 e con registri che permettono la "messa a piombo", l'allineamento ed il serraggio delle lastre di vetro, operazioni che devono essere fatte solo dal lato interno del parapetto. Sono previsti 4 kit ogni metro di profilo).

Il vetro, sia sul lato esterno sia sul lato interno entra in contatto soltanto con i registri in materiale plastico. Le guarnizioni inserite nelle cave dei profili completano la chiusura superiore tra vetro e profilo in alluminio.`;

export const LABORATORY_TESTS_TEXT = `Il parapetto (completo di alluminio, vetro ed accessori) dovrà essere dotato di prove eseguite in laboratorio nel pieno rispetto delle seguenti norme:

1. Decreto Ministeriale del 17/1/2018 (norme tecniche per le costruzioni);
2. UNI 11678:2017 che identifica la modalità di prova sia statica che dinamica sui parapetti vetrati;
3. UNI 7697:2021 definisce la tipologia di vetro da utilizzare ed il requisito post-rottura per parapetti vetrati;
4. Disegni tecnici con le dimensioni e lo spessore del vetro, del tipo di interlayer usato per la stratifica del vetro;
5. L'attestato deve riportare tutte le foto del campione durante le fasi delle prove, le quali illustrano anche il tipo di montaggio con il parapetto libero da ogni vincolo laterale. Le singole pagine dovranno essere timbrate dall'ente certificatore.

Il progettista o il direttore dei lavori si riservano di richiedere la prova direttamente in cantiere (con lo stesso sistema e norme usate in laboratorio) per controllarne la rispondenza ed anche la validità del fissaggio del parapetto in opera.`;
